import paths from '../../../config/local/paths';
import images from '../../../config/local/images';
import { translate } from '../../Internationalization';

export const PROPERTY_SCOPED_NAV_ITEMS = [
	{
		icon: images.icons.marketValuation,
		key: 'market',
		label: translate(
			'homeowner.pages.properties.scoped.submenu.market_valuation'
		),
		path: paths.app.homeowner.properties.scoped.marketValuation,
	},
	{
		icon: images.icons.finances,
		key: 'finances',
		label: translate('homeowner.pages.properties.scoped.submenu.finances'),
		path: paths.app.homeowner.properties.scoped.finances,
	},
	{
		icon: images.icons.properties,
		key: 'details',
		label: translate('homeowner.pages.properties.scoped.submenu.details'),
		path: paths.app.homeowner.properties.scoped.details,
	},
	{
		icon: images.icons.documents,
		key: 'documents',
		label: translate('homeowner.pages.properties.scoped.submenu.documents'),
		path: paths.app.homeowner.properties.scoped.documents,
	},
	{
		icon: images.icons.applianceCenter,
		key: 'appliances',
		label: translate(
			'homeowner.pages.properties.scoped.submenu.appliances'
		),
		path: paths.app.homeowner.properties.scoped.appliances,
	},
	{
		icon: images.icons.groups,
		key: 'team',
		label: translate('homeowner.pages.properties.scoped.submenu.team'),
		path: paths.app.homeowner.properties.scoped.team,
	},
];

/**
 * @returns {typeof PROPERTY_SCOPED_NAV_ITEMS}
 */
export function getPropertyScopedNavItems() {
	return PROPERTY_SCOPED_NAV_ITEMS;
}

/**
 * @param {string} path
 * @param {string} propertyId
 * @returns {string}
 */
export function resolvePropertyPath(path, propertyId) {
	return path.replace(':propertyId', propertyId);
}
